<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div class="flex align-center">
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="gameName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="dataRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          size="small"
          class="ipt mr10"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable>
        </el-date-picker>
        <el-select v-model="gameType2" size="small" class="ipt mr10" placeholder="请选择奖品类型" clearable>
          <el-option value="1" label="积分">积分</el-option>
          <el-option value="2" label="优惠劵">优惠劵</el-option>
          <el-option value="3" label="实物">实物</el-option>
        </el-select>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="keyword"
          placeholder="请输入编号"
          size="small"
          class="ipt mr10"
          v-if="gameType !== 'collect_card'"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          v-if="gameType !== 'collect_card'"
          >查询</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <el-table
      :data="winningList.records"
      style="width: 100%"
      stripe
      border
      size="small"
    >
      <el-table-column
        type="index"
        label="序号"
        header-align="center"
        align="center"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="活动名称"
        width="180"
        prop="gameName"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="prizeName"
        label="奖品名称"
        width="180"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="memberMobile"
        label="中奖会员手机号"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="memberName"
        label="中奖人姓名"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="memberAddress"
        label="中奖人地址"
        v-if="gameType !== 'collect_card'"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="winningTime"
        label="中奖时间"
      >
        <template slot-scope="scope">
          <span v-if="gameType === 'collect_card'">{{
            scope.row.prizeTime
          }}</span>
          <span v-else>{{ scope.row.winningTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="prizeType"
        label="奖品类型"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.prizeType == '1'">积分</span>
          <span v-if="scope.row.prizeType == '2'">优惠劵</span>
          <span v-if="scope.row.prizeType == '3'">实物</span>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="核销码"
        prop="prizeType"
        key="prizeType"
        >
        <template slot-scope="scope">
          {{ scope.row.prizeType == 3 ?scope.row.redeemCode: '' }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="发放状态">
        <template slot-scope="scope">
          <span v-if="gameType === 'collect_card'">
            <span v-if="scope.row.sendStatus === 'yes'">已发放</span>
            <span v-if="scope.row.sendStatus === 'no'">未发放</span>
            <el-button
              style="margin-left: 10px"
              type="primary"
              v-if="scope.row.sendStatus === 'no'"
              size="mini"
              @click="sendGift(scope.row.id)"
            >
              立即发放
            </el-button>
          </span>
          <span v-else>{{ scope.row.sendState }}</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="发放人">
        <template slot-scope="scope">
          <span v-if="gameType === 'collect_card'">{{
            scope.row.updateBy
          }}</span>
          <span v-else>{{ scope.row.sendOperator }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="winningList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
// import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      keyword: "",
      prizeType: "",
      dataRange: [],
      isOutputing: false,
      gameType: "",
      gameId: "",
      winningList: {
        records: [],
        total: 0
      },
      startTime: "",
      endTime: "",
      gameType2: "",
      gameName: ""
    };
  },
  // computed: mapGetters([
  //   "winningList",
  //   "allWinningList",
  //   "collectCardWinningList",
  //   "allCollectCardWinningList"
  // ]),
  watch: {},
  created() {
    this.gameType = this.$route.query.gameType;
    this.gameId = this.$route.query.gameId;
    // 获取当前时间
    const now = moment();

    // 获取3天前的时间
    const threeDaysAgo = moment().subtract(3, 'days');

    // 格式化时间（例如：YYYY-MM-DD HH:mm:ss）
    const formattedThreeDaysAgo = threeDaysAgo.format('YYYY-MM-DD') + ' ' + '00:00:00';
    const formattedNow = now.format('YYYY-MM-DD') + ' '+ '23:59:59';
    console.log("formattedThreeDaysAgo", formattedThreeDaysAgo);
    console.log("formattedNow", formattedNow);
    this.startTime = formattedThreeDaysAgo;
    this.endTime = formattedNow;
    this.dataRange = [formattedThreeDaysAgo, formattedNow];
  },
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    async sendGift(id) {
      await this.$store.dispatch("changeCollectCardGamePrizeStatus", {
        id
      });
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.queryList();
    },
    queryAllList() {
      let actionName = "queryAllWinningList";
      if (this.gameType === "collect_card") {
        actionName = "queryAllCollectCardWinningList";
      }
      return this.$store.dispatch(actionName, {
        pageNo: 1,
        pageSize: 99999,
        gameId: this.gameId
      });
    },
    async queryList() {
      let actionName = "queryWinningList";
      if (this.gameType === "collect_card") {
        actionName = "queryCollectCardWinningList";
      }
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyWords: this.keyword,
        prizeType: this.prizeType,
        gameId: this.gameId,
        gameType: this.gameType2,
        gameName: this.gameName
      }
      if(this.dataRange && this.dataRange.length) {
        this.startTime = this.dataRange[0];
        this.endTime = this.dataRange[1];
        params.startTime = this.dataRange[0];
        params.endTime = this.dataRange[1];
      }
      this.setParamsCookie(params);
      const { result } = await this.$store.dispatch(actionName, params);
      this.winningList = result;
    },
    setParamsCookie(params) {
      setCookie({
        key: "winningListParams",
        type: "session",
        data: Object.assign({}, params)
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "winningListParams", type: "session" });
      if (prams) {
        this.keyword = prams.keyword;
        this.pageSize = prams.pageSize || 10;
        this.currentPage = prams.currentPage || 1;
        this.gameName = prams.gameName;
        this.gameType2 = prams.gameType;
        if (prams.startTime && prams.endTime) {
          this.dataRange = [prams.startTime, prams.endTime];
          this.startTime = prams.startTime;
          this.endTime = prams.endTime;
        }
      }
    },
    async output() {
      require.ensure([], async () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const { result } = await this.queryAllList();
        const list = result.records;
        list.forEach(v => {
          if (v.prizeType == "1") {
            v.prizeType = "积分";
          } else if (v.prizeType == "2") {
            v.prizeType = "优惠劵";
          } else if (v.prizeType == "3") {
            v.prizeType = "实物";
          }
        });

        let tHeader = [
          "活动名称",
          "奖品名称",
          "中奖会员手机号",
          "中奖人姓名",
          "中奖人地址",
          "中奖时间",
          "奖品类型",
          "发放状态",
          "发放人"
        ];
        let filterVal = [
          "gameName",
          "prizeName",
          "memberMobile",
          "memberName",
          "memberAddress",
          "winningTime",
          "prizeType",
          "sendState",
          "sendOperator"
        ];
        if (this.gameType === "collect_card") {
          list.forEach(v => {
            v.sendStatusFormat = v.sendStatus === "yes" ? "已发放" : "未发放";
          });
          tHeader = [
            "活动名称",
            "奖品名称",
            "中奖会员手机号",
            "中奖人姓名",
            "中奖时间",
            "奖品类型",
            "发放状态",
            "发放人"
          ];
          filterVal = [
            "gameName",
            "prizeName",
            "memberMobile",
            "memberName",
            "prizeTime",
            "prizeType",
            "sendStatusFormat",
            "updateBy"
          ];
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(
          tHeader,
          data,
          "获奖名单" + new Date().toLocaleString()
        );
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.align-center {
  align-items: center;
}
</style>
